import React, { useEffect, useState, useRef } from "react";
import { actionCart } from '../../service/cartService';
import { getStoreBySKU } from "../../service/storeService";
import { getEXP } from "../../service/hotdealService";
import { useLocation } from '@reach/router';
import Breadcrumbs from '../Breadcrumbs';
import { Timer, TimerProductDetail } from '../Timer';
import { Des } from "../Products/description";
import { FromatNumberVIE, RoundFloor } from '../../utils/format'
import { isAuth } from "../../helpers/general";
import Gallery from '../Products/Gallery'
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import Tag from "../Products/Tag";
import BundleProduct from "../BundleProduct";
import ProductSame from '../ProductSame'
// import HeadSEO from "../Head";
import Rate from "../Rate";
import { getListGiftDetail, getListGift_v1, getListPromotion_v1 } from '../../service/campaignService';
import { checkWWishlist, deleteWishlist, createWishlist, addProductToWishlist } from '../../service/wishlistService';
import { responsiveproductlist, FunctionId } from "../../utils/constant";
import { getProductMetaKey } from "../../service/biboMartService";
import {pushtracking} from '../../service/trackingService';
// import {Helmet} from "react-helmet";
import ReactHtmlParser from 'react-html-parser';

import { TabView, TabPanel } from 'primereact/tabview';
import "./productdetail.css"
import { toast } from "react-toastify";

const ProductDetai = (item) => {
    const location = useLocation();
    let uri = location.pathname?.replace('.html', '').replace('/', '');
    const temp_color = [];
    const [temp_color_only, settemp_color_only] = useState([]);
    const _temp_color_only = [];
    const data_color = [];
    const [promoCode, setPromoPode] = useState('');
    const [combCode, setComboCode] = useState('');
    // const [promoType, setpromoType] = useState('');
    const [uuDai, setUuDai] = useState('');
    const [skuProduct, setskuProduct] = useState(item.sku);
    // const [totalTempCart, setTotalTempCart] = useState(0);
    const [data, setData] = useState(data_color);
    const [size, setSize] = useState([]);
    const [idSize, setIdSize] = useState(0);
    const [idSizeCheck, setIdSizeCheck] = useState(false);
    const [valueColor, setValueColor] = useState();
    var _color = [];
    const [configMsg, setConfigMsg] = useState(false);
    const time = new Date();
    const [store, setStore] = useState(0);
    const [isShowEXP, setIsShowEXP] = useState(false);
    const [timeEXP, setTimeEXP] = useState(0);
    const getDataEXP = () => {
        if (skuProduct !== undefined) {
            getEXP(item.item?.sku).then((reponse) => {
                if (reponse?.status === 200) {
                    setIsShowEXP(true);
                    setTimeEXP(reponse?.message?.exp_time);

                } else {
                    setIsShowEXP(false);
                }
            });
        }
    }
    const [itemsListPromotion, setItemsListPromotion] = useState([]);
    const [totalPriceCombo, setTotalPriceCombo] = useState(0);
    const [msgTotal, setMsgTotal] = useState('');
    const [totalGiftQty, setTotalGiftQty] = useState(0);
    const getDataListPromotion = (params, type) => {
        try {
            if (params !== undefined) {
                getListPromotion_v1(params, type).then((response) => {
                    if (+response.status === 200) {
                        setPromoPode(response.message?.products[0]?.promo_code);
                        setComboCode(response.message?.products[0]?.nameGroup);
                        setItemsListPromotion(response.message?.products);
                        setTotalPriceCombo(response.message?.total_price_combo);
                        setMsgTotal(response.message?.mes_text);
                        setTotalGiftQty(response.message?.soluong_tang_gifts);
                        setUuDai(response.message?.products[0]?.uudai);
                    } else {
                        setPromoPode('');
                        setComboCode('');
                        setTotalPriceCombo(0);
                        setMsgTotal('');
                        setTotalGiftQty(0);
                    }
                });
            }
        } catch (error) {
            console.log(error);
        }
    }

    const [msgGift, setMsgGift] = useState([]);
    const loadPromotionMsg = (sku, type) => {
        if (sku !== undefined && type !== '') {
            getListGiftDetail(sku, type).then((reponse) => {
                if (reponse?.status === 200) {
                    setMsgGift(reponse?.message?.messageBrand);
                }
            });

        }
    }

    const [itemGift, setItemGift] = useState([]);
    const loadDataGift = (sku, type) => {
        setItemGift([]);
        if (sku !== undefined) {
            getListGift_v1(sku, type).then((reponse) => {
                if (reponse?.status === 200) {
                    setItemGift(reponse?.message?.products);
                }
            });
            if (window.localStorage.getItem("tempCart") && window.localStorage.getItem("tempCart") !== '') {
                let param_gift_old = JSON.parse(window.localStorage.getItem("tempCart"));

                param_gift_old.map((item, key) => {
                    if (item.type === 'gift') {
                        param_gift_old.splice(key);
                    }
                });
                window.localStorage.setItem("tempCart", JSON.stringify(param_gift_old));
            }
        }
    }

    const getDataStoreBySKU = (sku) => {
        try {
            if (sku !== undefined) {
                getStoreBySKU(sku).then((response) => {
                    if (+response.status === 200) {
                        setStore(response.message.length ?? 0)
                    }
                });
            }
        } catch (error) {
            console.log(error);
        }
    }

    const [productMeta, setProductMeta] = useState([]);
    const getDataProductMeta = (sku, store_id) => {
        try {
            if (sku !== undefined) {
                getProductMetaKey(sku, store_id).then((response) => {
                    if (+response.status === 200) {
                        if(response.items.length > 0){
                            response.items[0]['meta_url']=window.location.href;
                            response.items[0]['meta_site']=window.location.host;
                            setProductMeta(response.items[0]);
                        }
                    }
                });
            }
        } catch (error) {
            console.log(error);
        }
    }

    const [typekm, setTypekm] = useState('');
    useEffect(() => {
        let defaullink = window.localStorage.getItem('typepage');
        if (defaullink && defaullink === 'product' || defaullink === '') {
            if (item?.item === 'Không tìm thấy thông tin sản phẩm!') {
                // window.location.href = '/404.html';
                window.location.href = location.origin;
            }
        }

        item.item?.children?.forEach((it, i) => {
            // if (!temp_color.includes(item.variant?.mau_sac) || !temp_color.includes(item.variant?.mau_sac_test)) {
                if (it.variant?.mau_sac_test !== '') {
                    // if (!temp_color.includes(it.variant?.mau_sac_test)) {
                        if(_color.includes(it.variant?.mau_sac_test) !== true){
                            _color.push(it.variant?.mau_sac_test)
                        }
                        temp_color.push({
                            color: it.variant?.mau_sac_test,
                            sku: it.variant?.sku
                        })
                        _temp_color_only.push({
                            id: i,
                            colorName: it.variant?.mau_sac_test,
                            sku: it.variant?.sku,
                            online: it.online
                        });
                    // }

                } else {
                    // if (!temp_color.includes(it.variant?.mau_sac)) {
                        if(_color.includes(it.variant?.mau_sac) !== true){
                            _color.push(it.variant?.mau_sac)
                        }
                        temp_color.push({
                            color: it.variant?.mau_sac,
                            sku: it.variant?.sku
                        })
                        _temp_color_only.push({
                            id: i,
                            colorName: it.variant?.mau_sac,
                            sku: it.variant?.sku,
                            online: it.online
                        });
                    // }
                }
    
            // }

        }
        );
        _color.forEach((_temp_color,i)=>{
        const data_size = [];
        temp_color?.forEach((color) => {
                if(_temp_color === color.color){
                    item.item?.children?.forEach((item_chil) => {
                        if (item_chil.variant?.kich_c !== null && item_chil.variant?.sku === color.sku) {
                            data_size.push({
                                colorSize: item_chil.variant?.kich_c,
                                sku: item_chil.variant?.sku,
                                online: item_chil.online
                            })
                        }
                    }
                    );
                }
            });
            if (data_size.length >= 1) {
                data_color.push({
                    color: { id: i, colorName: _temp_color },
                    size: data_size
                })
                setIdSizeCheck(true);
            }else{
                settemp_color_only(_temp_color_only);
                setskuProduct(_temp_color_only[0]?.sku ?? item.item?.sku);
            }
        });
        getDataProductMeta(item.item?.sku, 1);
        window.localStorage.setItem("tempCart", '');
        window.scrollTo(0, 0);

        try {
            //bỏ hàng quà tặng
            // if (item.item?.typectkm !== undefined) {
            //     setTypekm(item.item?.typectkm);
            //     loadPromotionMsg(item.item?.sku, item.item?.typectkm);
            //     loadDataGift(item.item?.sku, item.item?.typectkm);
            //     let _param = [{
            //         itemCode: item.item?.sku,
            //         price: item.item?.price.raw,
            //         quantity: 1
            //     }]
            //     getDataListPromotion(_param, item.item?.typectkm);
            // }
            getDataStoreBySKU( item.item?.sku);
            getDataEXP(skuProduct);
            setQuantity(1);
            setTimeout(function () {
                window.localStorage.setItem('typepage', '');
            }, 1000);
        } catch (err) {
            console.error(err);
        }
        if (promoCode !== '' && combCode !== '') {
            let _param = {
                "product": item.item?.sku,
                "type": "item",
                "action": "add",
                "quantity": 1,
                "price": item.item?.price.raw,
                "promo_code": promoCode ?? '',
                "combo_code": combCode ?? '',
                "promo_type": typekm ?? '',
                "uudai": uuDai ?? '',
                "user_referral": window.localStorage.getItem('userReferral'),
                "id_share": window.localStorage.getItem('idShare')
            }
            addCart(_param);
        }
        time.setSeconds(time.getSeconds() + timeEXP);
        setData(data_color);
        setValueColor(data_color[0]?.color?.colorName);
        setSize(data_color[0]?.size);
        // if(data_color[0]?.size?.length >0){
        //     setskuProduct(data_color[0]?.size[0]?.sku);
        //     setSelectedSize(data_color[0]?.size[0]?.sku);
        // }
        var _pageViewDetailMSG = sessionStorage.getItem("pageViewDetailMSG");
        if (_pageViewDetailMSG !== undefined && +_pageViewDetailMSG !== 1) {
            if(item.item?.function !== undefined && FunctionId.includes(item.item?.function)===true){
                if(item.item?.attribute?.age_group_from !== undefined && +item.item?.attribute?.age_group_from < 24){
                    setTimeout(function() {
                        setConfigMsg(true);
                    }, 9000);
                    // setConfigMsg(true);
                    sessionStorage.setItem("pageViewDetailMSG", 1);
                }
            }
        } 
       
    }, [uri, item, timeEXP]
    );
    //Tăng giảm số lượng
    const [quantity, setQuantity] = useState(1);
    const handlePlusClick = () => {
        setQuantity(quantity + 1);

        if (promoCode !== '' && combCode !== '') {
            let _param = {
                "product": item.item?.sku,
                "type": "item",
                "action": "add",
                "quantity": quantity + 1,
                "promo_code": promoCode,
                "combo_code": combCode,
                "promo_type": typekm,
                "uudai": uuDai,
                "user_referral": window.localStorage.getItem('userReferral'),
                "id_share": window.localStorage.getItem('idShare')
            }
            addCart(_param);
        }

    };

    const handleMinusClick = () => {
        if (quantity > 1) {
            setQuantity(quantity - 1);
            if (promoCode !== '' && combCode !== '') {
                let _param = {
                    "product": skuProduct,
                    "type": "item",
                    "action": "add",
                    "quantity": quantity - 1,
                    "promo_code": promoCode,
                    "combo_code": combCode,
                    "promo_type": typekm,
                    "uudai": uuDai,
                    "user_referral": window.localStorage.getItem('userReferral'),
                    "id_share": window.localStorage.getItem('idShare')
                }
                addCart(_param);
            }

        }
    };
    const [selectedColor, setSelectedColor] = useState(0);

    const handleColorClick = (e) => {
        const id = e?.target.id;
        setSelectedColor(+id);
        setSize(data[id]?.size);
        setValueColor(data[id]?.color?.colorName);
        setskuProduct('');
        setSelectedSize('');
        setStore(0)
    };
    const handleColorOnlyClick = (e) => {
        const id = e?.target.id;
        setSelectedColor(+id);
        const skuValue = e?.target.getAttribute("sku");
        skuRef.current.value = skuValue;
        setskuProduct(skuValue);
        getDataStoreBySKU(skuValue);
        setSelectedSize(skuValue);
    };
    //Chọn size
    const [selectedSize, setSelectedSize] = useState();
    
    const handleSizeClick = (e) => {
        const id = e?.target.id;
        setIdSize(id);
        const skuValue = e?.target.getAttribute("sku");
        skuRef.current.value = skuValue;
        setskuProduct(skuValue);
        getDataStoreBySKU(skuValue);
        setSelectedSize(skuValue);
    };

    const selectedBackgroundColor = 'red';
    const selectedTextColor = 'white';
    const liStyle = {
        backgroundColor: selectedBackgroundColor,
        color: selectedTextColor,
    };
    const percen = +item.item?.price?.discount / item.item?.price?.raw * 100;

    const skuRef = useRef(null);
    const nameRef = useRef(null);
    const imgRef = useRef(null);
    const quanityRef = useRef(null);
    const colorRef = useRef(null);
    const sizeRef = useRef(null);
    const priceRef = useRef(null);
    const pricediscountedRef = useRef(null);
    let handleByNow = async (e) => {
        e.preventDefault();
        if (isAuth() === false) {
            //toast.error('Bạn cần đăng nhập trước khi mua hàng.');
            window.localStorage.setItem('urlBack', location.pathname);
            setTimeout(() => { window.location.href = '/dang-nhap.html' }, 3500);
        } else {
            if(idSizeCheck === true){
                if(idSize === 0){
                    toast.warn('Vui lòng chọn thông tin kích cỡ.');
                    return;
                }
            }
            if (window.localStorage.getItem("tempCart") && window.localStorage.getItem("tempCart") !== '') {
                let param_product_to_cart = JSON.parse(window.localStorage.getItem("tempCart"));
                pushtoCart({ "items": param_product_to_cart });
            } else {
                let params = {
                    items: [{
                        product: skuRef.current.value,
                        type: 'item',
                        action: 'add',
                        quantity: +quanityRef.current.value,
                        promo_code: promoCode,
                        combo_code: combCode,
                        promo_type: typekm,
                        uudai: uuDai,
                        user_referral: window.localStorage.getItem('userReferral'),
                        id_share: window.localStorage.getItem('idShare')
                    }]
                }
                pushtoCart(params, true);
            }
        };
    }


    let handleBy = async (e) => {
        e.preventDefault();
        if (isAuth() === false) {
            //toast.error('Bạn cần đăng nhập trước khi mua hàng.');
            window.localStorage.setItem('urlBack', location.pathname);
            setTimeout(() => { window.location.href = '/dang-nhap.html' }, 3500);
        } else {

            if(idSizeCheck === true){
                if(idSize === 0){
                    toast.warn('Vui lòng chọn thông tin kích cỡ.');
                    return;
                }
            }
            if (window.localStorage.getItem("tempCart") && window.localStorage.getItem("tempCart") !== '') {
                let param_product_to_cart = JSON.parse(window.localStorage.getItem("tempCart"));
                pushtoCart({ "items": param_product_to_cart });
            } else {
                let params = {
                    items: [{
                        product: skuRef.current.value,
                        type: 'item',
                        action: 'add',
                        quantity: +quanityRef.current.value,
                        promo_code: promoCode,
                        combo_code: combCode,
                        promo_type: typekm,
                        uudai: uuDai,
                        user_referral: window.localStorage.getItem('userReferral'),
                        id_share: window.localStorage.getItem('idShare')
                    }]
                }
                pushtoCart(params);
            }
        }
    };

    const [isShowChooseSize, setIsShowChooseSize] = useState(false)
    const handleClickChooseSize = () => {
        setIsShowChooseSize(!isShowChooseSize);
    }

    const pushtoCart = (paramItem, redirect = false) => {
        if (isAuth() === true) {
            try {
                actionCart(paramItem, window.localStorage.getItem('key')).then((response) => {
                    if(+response.status === 200 && response.message.length > 0){
                    window.localStorage.setItem('reloadCart', true);
                    window.localStorage.setItem('itemsCart', JSON.stringify(response['message']));
                    if (response['message'].includes('Yêu cầu không') === true) {
                        toast.warning(response['message']);
                        return;
                    } else {
                        toast.success('Thêm vào giỏ hàng thành công.');
                        if (redirect) { setTimeout(() => { window.location.href = '/cart.html'; }, 2500); }
                    }
                    }
                })

                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push({ ecommerce: null });
                        window.dataLayer.push({
                                'event': 'add_to_cart',
                                'ecommerce': {
                                'currency': "VND",
                                'value': +item.item?.price.raw,
                                    'items': [
                                    {
                                        item_id: skuRef.current.value,
                                        item_name: item.item?.name,
                                        price: +item.item?.price.raw
                                    }
                                    ]
                                }
                            });

                            try{
                                pushtracking(window.localStorage.getItem('sessionId')??null,
                                window.localStorage.getItem('_id')??null,
                                window.localStorage.getItem('phone')??null ,
                                location.pathname, "Chi tiết sản phẩm", 0,0,'index','inWeb',[skuRef.current.value],'Website PC').then((response)=>{
                                    console.log('send tracking');
                                });
                            }catch(e){console.log(e)}

            } catch (err) {
                console.log(err);
            }
        }
    }

    const handleListPlusClick = (sku, item, gift) => {

        var el = document.getElementById("quantity_" + sku);
        let _value = el.value;
        el.value = +_value + 1;

        var _type = '';
        var _price = 0;
        var _sku = '';
        if (gift === true) {
            _type = 'gift';
            _price = item.price;
            _sku = item.sku_gifts;
        } else {
            _type = 'item';
            _price = item.price?.raw;
            _sku = item.sku;
        }

        let _param = {
            "product": _sku,
            "type": _type,
            "action": "add",
            "quantity": +_value + 1,
            "price": _price,
            "promo_code": item.promo_code,
            "combo_code": combCode,
            "promo_type": typekm,
            "uudai": uuDai,
            "user_referral": window.localStorage.getItem('userReferral'),
            "id_share": window.localStorage.getItem('idShare')
        }
        addCart(_param);

    };

    const handleListMinusClick = (sku, item, gift) => {
        var el = document.getElementById("quantity_" + sku);
        let _value = el.value;
        if (_value > 0) {
            el.value = +_value - 1;
            var _type = '';
            var _price = 0;
            var _sku = '';
            if (gift === true) {
                _type = 'gift';
                _price = item.price_gifts;
                _sku = item.sku;
            } else {
                _type = 'item';
                _price = item.price;
                _sku = item.sku_gifts;
            }
            let _param = {
                "product": _sku,
                "type": _type,
                "action": "add",
                "quantity": +_value - 1,
                "price": _price,
                "promo_code": promoCode,
                "combo_code": combCode,
                "promo_type": typekm,
                "uudai": uuDai,
                "user_referral": window.localStorage.getItem('userReferral'),
                "id_share": window.localStorage.getItem('idShare')
            }

            addCart(_param);
        }
    };

    var param_gift = [];
    const addCart = (param) => {
        if (window.localStorage.getItem("tempCart")) {
            param_gift = JSON.parse(window.localStorage.getItem("tempCart"));
        }
        if (param_gift.length > 0) {
            param_gift?.forEach((item, key) => {
                if (item.product === param.product && item.type === param.type) {
                    param_gift.splice(key, 1);
                }
                item['promo_code'] = promoCode;
                item['combo_code'] = combCode;
                item['promo_type'] = typekm;
                item['uudai'] = uuDai;
            })
            param_gift.push(param);
        } else {
            param_gift.push(param);
        }
        window.localStorage.setItem("tempCart", JSON.stringify(param_gift));

        const product_key = [];
        // product_key.push(119895);
        product_key.push(skuProduct);
        var total_price_gift = 0;
        var total_qty = 0;
        param_gift?.forEach((item) => {
            if (item.type === "gift") {
                total_price_gift = total_price_gift + (item.price * item.quantity);
                total_qty = total_qty + item.quantity;
            }
            if (item.type === 'item') {
                product_key.push(item.product);
            }
        });
        var array_param = [];
        param_gift?.forEach((item) => {
            if (item.type !== "gift") {
                var _temp = {
                    itemCode: item.product,
                    price: item.price,
                    quantity: +item.quantity
                }
                array_param.push(_temp);
            }
        });
        // getDataListPromotion(array_param, typekm);



        if (param.type === "gift") {
            if (typekm === 'MUAHANGTANGQUA') {
                if (msgTotal !== '') {
                    toast.warning(msgTotal);
                } else if (total_price_gift > totalPriceCombo) {
                    toast.error("Quà tặng vượt quá giá trị KM được hưởng");
                }
            }
            if (typekm === 'MUAHANGATANGHANGA') {
                if (msgTotal !== '') {
                    toast.warning(msgTotal);
                }
                if (total_qty > totalGiftQty) {
                    toast.error("Quà tặng vượt quá số lượng KM được hưởng");
                }
            }

        }
        let key_product = JSON.stringify(product_key).replaceAll('"', '').replaceAll('[', '').replaceAll(']', '');
        if (param.type === 'item') {
            loadPromotionMsg(key_product, typekm);
        }
    }

    const [isContactCheck, setIsContactCheck] = useState(false);
    const [modalCallIsOpen, setModalCallIsOpen] = useState(false);
    const [modalChatIsOpen, setModalChatIsOpen] = useState(false);
    
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth', // Cuộn mềm mại
        });
    };
    const handleCall = () => {
        window.location.href = `tel:${18006886}`;
    }
    const handleChatMess = () => {
        //window.location.href = 'https://m.me/BiBoMart.com.vn';
        window.open('https://m.me/BiBoMart.com.vn', '_blank');
    }
    const handleChatZalo = () => {
        //window.location.href = 'https://zalo.me/360706546542426311?src=qr';
        window.open('https://zalo.me/360706546542426311?src=qr', '_blank');
    }
    const handleRedirrect = (uri) => {
        window.location.href = uri;
    }
    const openModalCall = () => {
        setModalCallIsOpen(true);
        console.log('Show popup call');
    }

    const [wishlist, setWishlist] = useState(false);
    const handleWishlist = (sku, isFavorite) => {
        if (window.localStorage.getItem('key')) {
            setWishlist(!wishlist);
            checkWWishlist(window.localStorage.getItem('_id'), window.localStorage.getItem('_id'), sku).then((response) => {
                console.log(response);
            })

            if (isFavorite) {
                deleteWishlist(window.localStorage.getItem('_id'), window.localStorage.getItem('_id'), sku).then((response) => {
                    console.log(response);
                })
            } else {
                let param = {
                    "code": window.localStorage.getItem('_id'),
                    "user_id": window.localStorage.getItem('_id'),
                    "name": "danh-sach-yeu-thich",
                    "source": "cusapp",
                    "type": "",
                };
                createWishlist(param).then((response) => {
                    if (+response.status === 200) {
                        let data = {
                            "wishlist_id": window.localStorage.getItem('_id'),
                            "user_id": window.localStorage.getItem('_id'),
                            "product_id": sku,
                        };
                        addProductToWishlist(data).then((response) => {
                            console.log(response);
                        })
                    }
                })
            }
        }
    }
    return (

        <>
         {/* <HeadSEO key="Head" item={productMeta}  title={item.item?.name}/> */}
        {/* { productMeta &&  productMeta.length > 0 ?(
            <Head key="Head" item={productMeta} />
        ):(
            <Helmet>
            <title>{item.item?.name}</title>
            <meta name="description" content="Hệ thống siêu thị Mẹ và Bé Bibo Mart chuyên cung cấp đồ cho mẹ bầu, đồ sơ sinh, tã sữa, đồ chơi, xe đẩy, giường cũi, sản phẩm dành riêng cho mẹ bé giá tốt và chia sẻ những kiến thức hữu ích nhất." />
            <meta name="keywords" content="bibomart, bibo mart, bibo, shop mẹ và bé, cửa hàng mẹ bé, đồ sơ sinh, đồ cho mẹ bầu, bà bầu" />
            </Helmet>
        )} */}
            
            <div className="container page-builder-ltr ">
                <div className="container-menu">
                    {
                        <Breadcrumbs key="Breadcrumbs"
                            crumbs={[
                                { link: '/', label: 'Trang chủ' },
                                { label: item.item?.name },
                            ]}
                        />
                    }
                </div>
            </div>
            <div className="container page-builder-ltr detail-nav product-detail">
                <div className="container-detail">
                    {/* <form onSubmit={handleSubmit}> */}
                    <div className="detail-image-nav">
                        <input ref={skuRef} hidden name="sku" defaultValue={skuProduct ?? item.item?.sku} />
                        <input ref={nameRef} hidden name="name" defaultValue={item.item?.name} />
                        <input ref={imgRef} hidden name="img" defaultValue={item.item?.thumbnail_mini} />
                        <div className="container-detail-image">
                            {

                                item.item?.attribute ? (<Gallery images={item.item?.attribute?.images} />) : (null)
                            }

                            {
                                item.item?.namePromotion && item.item?.namePromotion !== 'Mua là có quà' ? (<Tag tag={item.item?.namePromotion} classTag="gifts" />) : (null)
                            }

                        </div>

                        <div className="container-detail-nav">
                            {/* <h1 className="d-none">{item.item?.name}</h1> */}
                            <div>
                                <span>{item.item?.name}</span>
                            </div>

                            <div className="detail-nav-code">
                                <span>MSP: {item.item?.sku}</span>
                                <Rate rate={item.item?.rate} />
                            </div>

                            <div className="detail-nav-price">
                                {
                                    item.item?.price ? (
                                        +item.item?.price.discount == +item.item?.price.raw ? (
                                            <div className="detail-nav-box">
                                                <span className="detail-price-new">{FromatNumberVIE(item.item?.price.raw)}đ</span>
                                                <input hidden ref={priceRef} name="price" defaultValue={item.item?.price.raw} />
                                                <input hidden ref={pricediscountedRef} name="price_old" defaultValue="0" />
                                            </div>
                                        ) : (
                                            <>
                                                <img src="/images/product_detail/fire.png" alt="icon" title="icon" />
                                                <input hidden ref={priceRef} name="price" defaultValue={item.item?.price.discount} />
                                                <input hidden ref={pricediscountedRef} name="price_old" defaultValue={item.item?.price.raw} />
                                                <span className="detail-price-new">{FromatNumberVIE(item.item?.price.discount)}đ</span>
                                                <span className="detail-price-old">{FromatNumberVIE(item.item?.price.raw)}đ</span>
                                                <div className="detail-sale">
                                                    <span>{RoundFloor(100 - percen)}%</span>
                                                </div>
                                            </>

                                        )
                                    ) : (null)

                                }
                                {
                                    isShowEXP ? (<TimerProductDetail key="timer" expiryTimestamp={time} />) : (null)
                                }

                            </div>

                            {
                                msgGift.length > 0 ? (
                                    <div className="detail-nav-gift">
                                        <div className="gift-text">
                                            {
                                                msgGift.map((item, i) => {
                                                    return <> <div key={i}>{item}</div></>
                                                })
                                            }
                                        </div>
                                    </div>
                                ) : (null)
                            }
                            {
                                temp_color_only.length >= 1 ? (
                                    <div className="detail-nav-color-size">
                                        <div className="detail-color">
                                            <span>Màu sắc</span>
                                            <ul>
                                                {
                                                    temp_color_only?.map((item, i) => {
                                                        return item?.colorName !== '' ? (
                                                            item.online === true ? (<li key={item.id} data={item.id} className={item.id == selectedColor ? 'selected' : ''}
                                                                sku={item.sku}
                                                                onClick={(e) => handleColorOnlyClick(e)}
                                                            >
                                                                <div className="box-color" id={i} sku={item.sku} style={{ backgroundColor: item?.colorName }} >
                                                                    {
                                                                        item?.colorName?.includes('#') === false ? (item?.colorName) : (null)
                                                                    }
                                                                </div>
                                                            </li>) : (<li key={item.id} data={item.id}
                                                                sku={item.sku}
                                                                className="disabled_variant"
                                                            >
                                                                <div className="box-color" id={i} sku={item.sku} style={{ backgroundColor: item?.colorName }} >
                                                                    {
                                                                        item?.colorName?.includes('#') === false ? (item?.colorName) : (null)
                                                                    }
                                                                </div>
                                                            </li>)

                                                        ) : (null)
                                                    })
                                                }
                                            </ul>
                                        </div>
                                    </div>
                                ) : (null)
                            }

                            {
                                data && data.length >= 1 ? (
                                    <div className="detail-nav-color-size">
                                        <div className="detail-color">
                                            {

                                                data[0]?.color?.colorName !== '' && data[0]?.color?.colorName !== null ? (
                                                    <span>Màu sắc</span>
                                                ) : (null)
                                            }

                                            
                                            <ul>
                                                {
                                                    data[0]?.color?.colorName !== '' && data[0]?.color?.colorName !== null ? (
                                                    data?.map((item, i) => (
                                                        item?.color?.colorName !== '' ? (
                                                            <li key={item.color.id} data={item.color.id} className={item.color.id == selectedColor ? 'selected' : ''}
                                                                onClick={(e) => handleColorClick(e)}>
                                                                <div className="box-color" id={i} style={{ backgroundColor: item?.color?.colorName }} >
                                                                    {
                                                                        item?.color?.colorName?.includes('#') === false ? (item?.color?.colorName) : (null)
                                                                    }
                                                                </div>
                                                            </li>
                                                        ) : (null)
                                                    ))
                                                    ):(null)
                                                }
                                            </ul>
                                            <input ref={colorRef} hidden name="color" defaultValue={valueColor} />
                                        </div>
                                        {
                                            size && size.length > 0 && size[0]?.colorSize !== null ? (
                                                <div className="detail-size">
                                                    <span>Kích cỡ</span>
                                                    <ul>
                                                        {
                                                            size?.map((item) => (
                                                                item.colorSize !== null ? (
                                                                    item.online === true ? (<li key={item.sku} style={selectedSize === item.sku ? liStyle : {}}
                                                                        sku={item.sku}
                                                                        id={item.colorSize} onClick={(e) => handleSizeClick(e)}>
                                                                        {item.colorSize}
                                                                    </li>) : (<div key={item.sku}
                                                                        sku={item.sku} className="disabled_variant in-f"
                                                                        id={item.colorSize}>
                                                                        {item.colorSize}
                                                                    </div>)

                                                                ) : (null)
                                                            ))
                                                        }
                                                    </ul>
                                                    <input ref={sizeRef} hidden name="size" defaultValue={selectedSize} />
                                                </div>
                                            ) : (null)
                                        }


                                    </div>
                                ) : (null)
                            }
                            <div className="detail-nav-number">
                                <span>Chọn số lượng</span>
                                <div className="detail-number">
                                    <div className="number-minus" onClick={handleMinusClick}><i className="fa fa-minus"></i></div>
                                    <div><input ref={quanityRef} className="number-now" name="quantity" value={quantity} readOnly></input></div>
                                    <div className="number-plus" onClick={handlePlusClick}><i className="fa fa-plus"></i></div>
                                </div>
                            </div>

                            {
                                //san pham co qua tang
                                itemGift.length > 0 ? (
                                    <div className="detail-item-gift box-slider-product">
                                        <span>Có <strong>{itemGift.length}</strong> sản phẩm cùng Khuyến mại</span>
                                        <div className="">
                                            <Carousel key="product-gift"
                                                responsive={responsiveproductlist}
                                                showDots={true}
                                                fade={true}
                                                autoPlay={true}
                                                autoPlaySpeed={2000}
                                            >
                                                {
                                                    itemGift.map((itemListgift, i) => {
                                                        return <div key={i} >
                                                            <img src={itemListgift.thumbnail} />
                                                            <span>{itemListgift.name.substring(0, 13)}...</span>
                                                            <div className="item-number">
                                                                <div className="item-plus">
                                                                    <i className="fa fa-minus" onClick={() => handleListMinusClick(itemListgift.sku, itemListgift, false)}></i>
                                                                </div>
                                                                <div>
                                                                    <input className="item-now" id={"quantity_" + itemListgift.sku} name="quantity" readOnly="" defaultValue="0" />
                                                                </div>
                                                                <div className="item-minus">
                                                                    <i className="fa fa-plus" onClick={() => handleListPlusClick(itemListgift.sku, itemListgift, false)}></i>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    })
                                                }
                                            </Carousel>
                                        </div>
                                    </div>

                                ) : (null)
                            }

                            {
                                // chọn quà tặng

                                itemsListPromotion.length > 0 ? (
                                    <div className="select-item-gift box-slider-product">
                                        <span className="select-title">Chọn quà kèm theo</span>
                                        <Carousel key="product-gift-promotion"
                                            responsive={responsiveproductlist}
                                            showDots={true}
                                            fade={true}
                                            autoPlay={true}
                                            autoPlaySpeed={2000}
                                        >
                                            {
                                                itemsListPromotion.map((gift, i) => {
                                                    return <React.Fragment key={i}>
                                                        <span className="special-text">Tặng</span>
                                                        <img className="img-item" src={gift.thumbnail_gifts.replace('/fullhd', '/thumb')} />
                                                        <input hidden defaultValue={gift.price_gifts} />
                                                        <div className="item-number">
                                                            <div className="item-plus">
                                                                <i className="fa fa-minus" onClick={() => handleListMinusClick(gift.sku + gift.sku_gifts, gift, true)}></i>
                                                            </div>
                                                            <div>
                                                                <input className="item-now" id={"quantity_" + gift.sku + gift.sku_gifts} name="quantity" readOnly="" defaultValue="0" />
                                                            </div>
                                                            <div className="item-minus">
                                                                <i className="fa fa-plus" onClick={() => handleListPlusClick(gift.sku + gift.sku_gifts, gift, true)}></i>
                                                            </div>
                                                        </div>
                                                    </React.Fragment>
                                                })
                                            }
                                        </Carousel>
                                    </div>
                                ) : (null)
                            }
                            {
                                item.item?.online === false ? (
                                    <div className="detail-store">
                                        <ul>
                                            <li></li>
                                            <li> <a className="detail-store-text"><div >Sản phẩm không bán online.</div></a></li>
                                        </ul>
                                    </div>
                                ) : (null)
                            }
                            <div className="detail-nav-button">
                                {
                                    item.item?.online === true && +item.item?.quantity >0 ? (
                                        <>
                                            <button className="button-add" onClick={handleBy}>THÊM VÀO GIỎ</button>
                                            <button className="button-buy" onClick={handleByNow}>MUA NGAY</button>
                                        </>
                                    ) : (
                                        <>
                                            <button className="button-add" disabled>THÊM VÀO GIỎ</button>
                                            <button className="button-buy" disabled>MUA NGAY</button>

                                        </>
                                    )
                                }

                                {/* <button className="button-buy" onClick={()=>handleByNow()}>MUA NGAY</button> */}
                                <div className="detail-nav-like">
                                    {/* <a href=""><i className="fa fa-heart"></i></a> */}
                                    <img onClick={() => handleWishlist(item.item.sku, item.item.isFavorite)} className="img-like" src={wishlist || item.item.isFavorite ? ("/../images/web_app/ic_like_active.svg") : ("https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/ic_like.png")} alt="icon" title="icon"/>
                                    <span>Yêu thích</span>
                                </div>
                            </div>

                            <div className="detail-nav-guide-store">
                                {
                                    +item.item?.category === 98 || +item.item?.category === 99 || +item.item?.category === 101 ? (
                                        <div className="detail-guide">
                                            <ul>
                                                <li><i className="fa fa-ruler"></i></li>
                                                <li>
                                                    <div className="row" onClick={() => handleClickChooseSize()}><a>&nbsp;Hướng dẫn chọn size</a></div>
                                                </li>
                                            </ul>
                                            {
                                                isShowChooseSize ? (<div className="row"><img src="/images/chon-size.png" alt="icon" title="icon" /></div>) : (null)
                                            }
                                        </div>
                                    ) : (null)
                                }

                                <div className="detail-store">
                                    <ul>
                                        <li><i className="fa fa-store pdr-5"></i></li>
                                        <li><a href="#" className="detail-store-text">
                                            {
                                                store > 0 ? (
                                                    <div> Có {store} cửa hàng hiện đang có sản phẩm này</div>
                                                ) : (
                                                    <div> Chưa có thông tin cửa hàng.</div>
                                                )
                                            }
                                        </a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* </form> */}
                    <div className="container-detail-menu">
                        <TabView>
                            <TabPanel header="MÔ TẢ SẢN PHẨM">
                                {
                                    item.item?.attribute ? (<Des des={item.item?.attribute?.description} />) : (null)
                                }
                            </TabPanel>
                            <TabPanel header="THÔNG TIN CHI TIẾT" >
                                {
                                    <div className="infor-detail">
                                        <table className="table table-striped">
                                            <tbody>
                                                <tr>
                                                    <td className="td1">Thương hiệu</td>
                                                    <td className="td2"><a className="brand-name" href={item.item?.attribute?.url_brand ? item.item?.attribute?.url_brand+".html" : null}>{item.item?.attribute?.brand_name ? item.item?.attribute?.brand_name : null}</a></td>
                                                </tr>
                                                <tr>
                                                    <td className="td1">Xuất xứ thương hiệu</td>
                                                    <td className="td2">{item.item?.attribute?.xuat_xu_thuong_hieu ? item.item?.attribute?.xuat_xu_thuong_hieu : null}</td>
                                                </tr>
                                                <tr>
                                                    <td className="td1">Nơi sản xuất</td>
                                                    <td className="td2">{item.item?.attribute?.noi_san_xuat ? item.item?.attribute?.noi_san_xuat : null}</td>
                                                </tr>
                                                <tr>
                                                    <td className="td1">Độ tuổi sử dụng</td>
                                                    <td className="td2">{item.item?.attribute?.nhom_tuoi_xu_dung ? item.item?.attribute?.nhom_tuoi_xu_dung : null}</td>
                                                </tr>
                                                <tr>
                                                    <td className="td1">Trọng lượng</td>
                                                    <td className="td2">
                                                        {item.item?.attribute?.trong_luong_san_pham ? item.item?.attribute?.trong_luong_san_pham + "g" : null}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                }
                            </TabPanel>
                        </TabView>
                    </div>
                </div>
            </div>

            <div className="container page-builder-ltr">
                <div className="row row_iart row-style mgx-0">
                    <BundleProduct sku={item.item?.sku} />
                    <ProductSame sku={item.item?.sku} />

                </div>
            </div>
            <div className="group-icon-bottom-right">
                <div onClick={() => handleRedirrect('/mobile/san-xu.html')} className={`mgt-10 ${isContactCheck === true ? 'd-block' : 'd-none'}`}>
                    <img src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/iconsanxu.png" alt="icon" title="icon"></img>
                </div>
                <div onClick={() => openModalCall()} className={`mgt-10 ${isContactCheck === true ? 'd-block' : 'd-none'}`}>
                    <img src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/iconcall.png" alt="icon" title="icon"></img>
                </div>
                <div onClick={() => setModalChatIsOpen(true)} className={`mgt-10 ${isContactCheck === true ? 'd-block' : 'd-none'}`}>
                    <img src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/iconchat.png" alt="icon" title="icon"></img>
                </div>
                <div onClick={() => setIsContactCheck(!isContactCheck)} className="mgt-10">
                    {
                        isContactCheck === true ? (
                            <img src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/iconx.png" alt="icon" title="icon"></img>

                        ) : (
                            <img src="https://bibomartcdn.multicdn.top/images/2024/8/1/123/origin/icon3cham.png" alt="icon" title="icon"></img>

                        )
                    }
                </div>
            </div>
                <div className="popup-function">
                    <div id="modal-call">
                        {modalCallIsOpen && (
                            <div className="modal">
                                <div className="modal-content">
                                    <div className="modal-body p-0">
                                        <div className="text-center">
                                            <button onClick={() => handleCall()} className="btn-confirm pdy-10">
                                                <i className="fas fa-headset text-red mgr-10"></i> Gọi 1800 6886 (Miễn phí)
                                            </button>
                                        </div>
                                        <div className="text-center mgt-10">
                                            <button onClick={() => setModalCallIsOpen(false)} className="btn-cancel pdy-10 mgt-10">
                                                Hủy
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>

                    <div id="modal-chat">
                    {modalChatIsOpen && (
                        <div className="modal">
                            <div className="modal-content">
                                <div className="modal-body p-0">
                                    <div className="text-center">
                                        <button onClick={() => handleChatMess()} className="btn-confirm pdy-10">
                                            Messenger
                                        </button>
                                    </div>
                                    <div className="text-center mgt-10">
                                        <button onClick={() => handleChatZalo()} className="btn-confirm pdy-10 mgt-10">
                                            Zalo
                                        </button>
                                    </div>
                                    <div className="text-center mgt-10">
                                        <button onClick={() => setModalChatIsOpen(false)} className="btn-cancel pdy-10 mgt-10">
                                            Hủy
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                    </div>

                    <div id="modal-msg">
                        {configMsg === true ? (
                        <div className="modal">
                            <div className="modal-content">
                                <div className="modal-body p-0">
                                    <div>
                                    Sữa mẹ là thức ăn tốt nhất cho sức khỏe và sự phát triển toàn diện của trẻ sơ sinh và trẻ nhỏ! Vui lòng xác nhận bạn là nhân viên y tế hoặc có nhu cầu tìm hiểu thông tin về sản phẩm theo chỉ dẫn của nhân viên y tế.
                                    </div>
                                    <div className="text-right mgt-10">
                                        <button onClick={() => setConfigMsg(false)} className="btn-cancel pdy-10 mgt-10">
                                            Xác nhận
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        ):(null)}
                    </div>

                </div>
            
        </>
    )

}

export default (ProductDetai)